import { createContextWithHooks } from '@/shared/utils/react';

export type ActionSlot = HTMLElement | null;

export type TabsMenuContextType = {
  actionsSlot: ActionSlot;
  registerActionSlot: (el: ActionSlot) => void;
};

const DISPLAY_NAME = 'TabsMenu';

const tabsMenuContext = createContextWithHooks<TabsMenuContextType>(DISPLAY_NAME);

export default tabsMenuContext;
